type FacebookOutlineIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const FacebookOutlineIcon = (props: FacebookOutlineIconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.9997 1.6665H12.4997C11.3946 1.6665 10.3348 2.10549 9.5534 2.88689C8.77199 3.66829 8.33301 4.7281 8.33301 5.83317V8.33317H5.83301V11.6665H8.33301V18.3332H11.6663V11.6665H14.1663L14.9997 8.33317H11.6663V5.83317C11.6663 5.61216 11.7541 5.4002 11.9104 5.24392C12.0667 5.08763 12.2787 4.99984 12.4997 4.99984H14.9997V1.6665Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
